import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Injector, OnInit } from '@angular/core';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-home-employee-master-popup',
  templateUrl: './home-employee-master-popup.component.html',
  styleUrls: ['./home-employee-master-popup.component.scss']
})
export class HomeEmployeeMasterPopupComponent implements OnInit {
  loggedInUserRole: any;
  loggedInCompanyHRID: any;
  loggedInUserId: any;
  loggedInUserCompanyID: any;
  selectedMonth: any;
  moduleName: any;
  selectedYear: any;
  activeEmployeeList: any = [];
  getActiveEmpCount: any;
  exitedEmployeeList: any = [];
  getExitedEmpCount: any;
  activeEmployeeSearchList: any = [];
  getActiveEmpSearchCount: any;
  searchData: any;

  constructor(
    private injector: Injector,
    private encryptionService: EncryptionService,
    private config: Config,
    private httpService: HttpService,
    public router: Router,
    public dialogRef: MatDialogRef<HomeEmployeeMasterPopupComponent>,
    public mobileResponsiveService: MobileResponsiveService
  ) {}

  ngOnInit() {
    const dialogData = this.injector.get(MAT_DIALOG_DATA);
    this.moduleName = dialogData.moduleName;
    this.selectedMonth = dialogData.month;
    this.selectedYear = dialogData.year;

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInCompanyHRID = sessionStorage.getItem('userCompanyHr');
    this.loggedInUserId = Number(sessionStorage.getItem('loggedInUserId'));
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.getEmpMasterList();
  }

  getEmpMasterList() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyHRID;
    } else {
      id = this.loggedInUserId;
    }
    let request = {};
    let moduleName: any;
    if (this.moduleName == 'Employee Search') {
      moduleName = 'Active Employee';
    } else {
      moduleName = this.moduleName;
    }
    if (id == 'null') {
      request = {
        companyId: this.loggedInUserCompanyID,
        month: this.selectedMonth,
        name: moduleName,
        userId: null,
        year: this.selectedYear,
        loggedInUserRole: this.loggedInUserRole,
        search: this.searchData || null
      };
    } else {
      request = {
        companyId: this.loggedInUserCompanyID,
        month: this.selectedMonth,
        name: moduleName,
        userId: id,
        year: this.selectedYear,
        loggedInUserRole: this.loggedInUserRole,
        search: this.searchData || null
      };
    }
    this.httpService.callPostService(this.config.getEmpMasterList, request).subscribe((result: any) => {
      if (this.moduleName == 'Active Employee') {
        this.activeEmployeeList = result;
        this.getActiveEmpCount = this.activeEmployeeList.length;
      } else if (this.moduleName == 'Employee Search') {
        let count: any;
        if (this.searchData == null) {
          this.activeEmployeeSearchList = [];
        } else {
          this.activeEmployeeSearchList = result;
        }
        this.getActiveEmpSearchCount = result.length;
      } else {
        this.exitedEmployeeList = result;
        this.getExitedEmpCount = this.exitedEmployeeList.length;
      }
    });
  }

  onSearchActiveEmployeee(data: any) {
    var search = '';
    this.searchData = data;
    if (data == '') {
      this.searchData = null;
      this.getEmpMasterList();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getEmpMasterList();
          }, 500);
        }
      }, 1500);
    }
  }

  onClickDownloadActiveEmpExcel(employeesearch: any) {
    // Pick correct data source based on moduleName
    const exportData = this.moduleName === 'Employee Search' ? this.activeEmployeeSearchList : this.activeEmployeeList;

    if (!exportData || exportData.length === 0) {
      console.warn('No data available to export');
      return;
    }

    // Date formatting helper
    const formatDate = (date: string) => {
      const formattedDate = new Date(date);
      if (!isNaN(formattedDate.getTime())) {
        return formattedDate.toLocaleDateString('en-GB'); // dd/MM/yyyy
      }
      return date;
    };

    // Flatten the employee list for Excel
    const flattenedData: any = exportData.map((ele: any) => ({
      'Employee Code': ele.employeeId,
      'Employee Name': ele.firstName + ' ' + ele.lastName,
      Gender: ele.gender,
      'Date Of Joining': formatDate(ele.dateOfJoining),
      'Company Name': ele.companyName,
      'Official Email': ele.officialEmail,
      'Dotted Reporting Manager Name': ele.dottedReportingManagerName,
      'HOD Name': ele.hodName,
      Band: ele.band,
      Grade: ele.grade,
      Designation: ele.designation,
      Department: ele.department,
      'Plant/office Location': ele.workLocationCity
    }));

    // Excel MIME type
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    // Create worksheet
    const worksheet: XLSX.WorkSheet | any = XLSX.utils.json_to_sheet(flattenedData);

    // Header style
    const headerStyle = {
      fill: {
        fgColor: { rgb: 'FF0000' } // Red background
      },
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' }, // White text
        sz: 14,
        name: 'Arial'
      }
    };

    // Apply style to first row
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }

    // Column widths
    worksheet['!cols'] = [{ wpx: 100 }, { wpx: 150 }, { wpx: 80 }, { wpx: 120 }, { wpx: 150 }, { wpx: 200 }, { wpx: 180 }, { wpx: 150 }, { wpx: 100 }, { wpx: 80 }, { wpx: 150 }, { wpx: 150 }, { wpx: 150 }];

    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };

    // Write workbook
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create blob & download
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = this.moduleName === 'Employee Search' ? 'Employee_Search.xlsx' : 'Active_Employees.xlsx';
    saveAs(data, fileName);
  }

  onClickDownloadExitedEmpExcel(exitedEmployeeList: any) {
    const formatDate = (date: string) => {
      const formattedDate = new Date(date);
      if (!isNaN(formattedDate.getTime())) {
        return formattedDate.toLocaleDateString('en-GB');
      }
      return date;
    };
    const flattenedData: any | undefined = exitedEmployeeList.map((ele: any) => ({
      'Employee Code': ele.employeeId,
      'Employee Name': ele.firstName + ' ' + ele.lastName,
      Gender: ele.gender,
      'Date Of Joining': formatDate(ele.dateOfJoining),
      'Company Name': ele.companyName,
      'Official Email': ele.officialEmail,
      'Dotted Reporting Manager Name': ele.dottedReportingManagerName,
      'HOD Name': ele.hodName,
      Band: ele.band,
      Grade: ele.grade,
      Designation: ele.designation,
      Department: ele.department,
      'Plant/office Location': ele.officeLocation,
      LWD: formatDate(ele.dateOfExit),
      'Date of Resignation': formatDate(ele.dateOfResignation)
    }));
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const worksheet: XLSX.WorkSheet | any = XLSX.utils.json_to_sheet(flattenedData);
    const headerStyle = {
      fill: {
        fgColor: { rgb: 'FF0000' }
      },
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' },
        sz: 14,
        name: 'Arial'
      }
    };
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }
    worksheet['!cols'] = [{ wpx: 100 }, { wpx: 150 }, { wpx: 80 }, { wpx: 120 }, { wpx: 150 }, { wpx: 200 }, { wpx: 180 }, { wpx: 150 }, { wpx: 100 }, { wpx: 80 }, { wpx: 150 }, { wpx: 150 }, { wpx: 150 }, { wpx: 150 }, { wpx: 150 }];

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Exited_Employees.xlsx';
    saveAs(data, fileName);
  }

  onClickGoToEmployeeMasterPage(id: any) {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      this.router.navigate(['/home/hrportal/employeemaster', { id: id, operation: 'Show' }]);
      this.dialogRef.close();
    }
  }

  //   onClickDownloadActiveEmpExcel(activeEmployeeList: any) {
  //     // Flatten data into the desired format
  //     const flattenedData:any | undefined = activeEmployeeList.map((ele: any) => ({
  //         "Employee Code": ele.employeeId,
  //         "Employee Name": ele.firstName + ' ' + ele.lastName,
  //         "Gender": ele.gender,
  //         "Date Of Joining": ele.dateOfJoining,
  //         "Company Name": ele.companyName,
  //         "Official Email": ele.officialEmail,
  //         "Dotted Reporting Manager Name": ele.dottedReportingManagerName,
  //         "HOD Name": ele.hodName,
  //         "Band": ele.band,
  //         "Grade": ele.grade,
  //         "Designation": ele.designation,
  //         "Department": ele.department,
  //         "Office Location": ele.officeLocation
  //     }));

  //     // Define Excel file type
  //     const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  //     // Create worksheet and apply styles
  //     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
  //     const headerStyle = {
  //         fill: {
  //             fgColor: { rgb: 'FF0000' } // Red background
  //         },
  //         font: {
  //             bold: true,
  //             color: { rgb: 'FFFFFF' }, // White text
  //             sz: 14,
  //             name: "Arial"
  //         }
  //     };

  //     // Apply styles to header row
  //      const range = XLSX.utils.decode_range(worksheet['!ref']); // Get the range of the worksheet
  //       for (let col = range.s.c; col <= range.e.c; col++) {
  //           const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 }); // Header row index is 0
  //           if (!worksheet[cellAddress]) continue; // Ensure cell exists
  //           worksheet[cellAddress].s = headerStyle; // Apply styles to the header
  //       }

  //     // Set column widths (optional)
  //     worksheet['!cols'] = [
  //         { wpx: 100 }, // Employee Code
  //         { wpx: 150 }, // Employee Name
  //         { wpx: 80 },  // Gender
  //         { wpx: 120 }, // Date Of Joining
  //         { wpx: 150 }, // Company Name
  //         { wpx: 200 }, // Official Email
  //         { wpx: 180 }, // Dotted Reporting Manager Name
  //         { wpx: 150 }, // HOD Name
  //         { wpx: 100 }, // Band
  //         { wpx: 80 },  // Grade
  //         { wpx: 150 }, // Designation
  //         { wpx: 150 }, // Department
  //         { wpx: 150 }  // Office Location
  //     ];

  //     // Create workbook and worksheet
  //     const workbook: XLSX.WorkBook = {
  //         Sheets: { 'data': worksheet },
  //         SheetNames: ['data'],
  //     };

  //     // Write workbook to Excel buffer
  //     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  //     // Save as Blob and trigger download
  //     const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
  //     const fileName = 'Active_Employee_Data.xlsx';
  //     saveAs(data, fileName);
  // }
}
